import { useState, useEffect } from 'react';
import { Modal, Button } from '@components/ui';
import { montajDurumlari } from '@mocks/materials/kapiPencere';

export default function MontajModal({ isOpen, onClose, onSubmit, data, isLoading = false }) {
    const [montajlanan, setMontajlanan] = useState(0);
    const [montajDurumu, setMontajDurumu] = useState('');
    const [not, setNot] = useState('');

    useEffect(() => {
        if (data) { setMontajlanan(data.montajlanan || 0); setMontajDurumu(data.montajDurumu || 'bekliyor'); }
    }, [data]);

    const handleChange = (val) => {
        const m = Math.min(data?.miktar || 0, Math.max(0, parseInt(val) || 0));
        setMontajlanan(m);
        if (m >= (data?.miktar || 0)) setMontajDurumu('tamamlandi');
        else if (m > 0) setMontajDurumu('devam');
    };

    const handleSubmit = () => { onSubmit({ montajlanan, montajDurumu, not }); };

    if (!data) return null;
    const inputClass = "w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/50";

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Montaj Güncelle" size="sm"
            footer={<><Button variant="ghost" onClick={onClose} disabled={isLoading}>İptal</Button><Button variant="success" onClick={handleSubmit} isLoading={isLoading}>Güncelle</Button></>}>
            <div className="space-y-4">
                <div className="p-3 bg-bg-tertiary rounded-lg">
                    <p className="font-medium text-text-primary">{data.urunAdi}</p>
                    <p className="text-sm text-text-muted">{data.ebat} • {data.malzeme}</p>
                    <p className="text-sm text-text-secondary mt-1">Toplam: {data.miktar} adet</p>
                </div>
                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Montajlanan Adet</label>
                    <input type="number" min={0} max={data.miktar} value={montajlanan} onChange={(e) => handleChange(e.target.value)} className={inputClass} />
                </div>
                <div className="space-y-1">
                    <div className="flex justify-between text-xs text-text-muted"><span>İlerleme</span><span>%{data.miktar > 0 ? Math.round((montajlanan / data.miktar) * 100) : 0}</span></div>
                    <div className="h-2 bg-bg-tertiary rounded-full overflow-hidden"><div className={`h-full rounded-full ${montajlanan >= data.miktar ? 'bg-success' : 'bg-warning'} transition-all`} style={{ width: `${(montajlanan / data.miktar) * 100}%` }} /></div>
                </div>
                <div><label className="block text-sm font-medium text-text-primary mb-1.5">Montaj Durumu</label>
                    <select value={montajDurumu} onChange={(e) => setMontajDurumu(e.target.value)} className={inputClass}>{montajDurumlari.map(m => <option key={m.key} value={m.key}>{m.label}</option>)}</select></div>
                <div><label className="block text-sm font-medium text-text-primary mb-1.5">Not</label>
                    <input type="text" value={not} onChange={(e) => setNot(e.target.value)} placeholder="Montaj notu..." className={inputClass} /></div>
            </div>
        </Modal>
    );
}
